export default __webpack_public_path__ + "static/media/sticker-L.5511a036.png";